import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import KeyPublicSchema from "@common/schema/key/public";
import * as HomeRoute from "./home";

// Read-only and single-page: the dashboard summarises what the organization
// holds, so there is nothing here to create, edit or address individually.
//
// The provider is VESTIGIAL — nothing on this screen renders a widget for a
// declared type, and Section.Provider is here only to supply `base`/`basepath`
// to the route below. datum's and bucketws' dashboards carry the same one for
// the same reason, each passing its own entity's schema.
//
// tablews has no entity yet, so it passes the key schema: any valid schema does,
// and inventing a table one before the entity exists would be a shape nothing
// else agrees with. Swap it for the table schema when that lands.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const base = `/dashboard`;
  const basepath = `/dashboard`;

  return (
    <Section.Provider
      schema={KeyPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={HomeRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Dashboard</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/`} component={HomeRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
